/**
 * `@matcha/app-config` reads `process.env.APP_ENV` behind a
 * `typeof process !== "undefined"` guard. Vite's `define` replaces the READ
 * but not the guard, so without this the guard is false in the browser and
 * the config silently falls back to its default environment.
 *
 * Imported first in `main.tsx`, before anything that touches app-config.
 *
 * The cast is unavoidable: `@types/node` is in this project for the vite
 * config, so the global `process` is typed as Node's full `Process` and a
 * two-field stand-in cannot be assigned to it. Nothing in the browser reads
 * more than `env`.
 */
const globals = globalThis as {
  process?: { env: Record<string, string | undefined> };
};
if (typeof globals.process === "undefined") {
  globals.process = { env: {} };
}

export {};
